import {getTrackedOfferData, ITrackedOffer} from "./tracked_utils/tracked_offer";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";
import {getTrackedVendorData, ITrackedVendor} from "./tracked_utils/tracked_vendor";
import {pageviewAlgolytics} from "./pageview_algolytics";

export const offerDetailPageview = (offer: ITrackedOffer, vendor: ITrackedVendor) => {
    const payload = {
        view_type: "offer",
        ...getTrackedSiteData(),
        ...getTrackedVendorData(vendor),
        ...getTrackedOfferData(offer)
    };
    pageviewAlgolytics(payload);
};
